import * as types from '../actions/actionTypes'


const userReducer = (state = {}, action) => {

    switch(action.type) {
      case types.GET_USER_DATA_SUCCESS: 
      state = {
        ...state,
        email: action.payload.email,
        firstName: action.payload.firstName,
        fullName: action.payload.fullName,
        lastName: action.payload.lastName,
        managerUID: action.payload.managerUID,
        officeName: action.payload.officeName,
        phoneNumber: action.payload.phoneNumber,
        region: action.payload.region,
        role: action.payload.role,
        officeAddress: action.payload.officeAddress,
        officeCity: action.payload.officeCity,
        officeNumber: action.payload.officeNumber,
        officeState: action.payload.officeState,
        officeZip: action.payload.officeZip,
        currentPoints: action.payload.currentPoints,
        runningTotal: action.payload.runningTotal,
        bonusLevelRank: action.payload.bonusLevelRank,
      };
      break;
      case types.SET_MANAGER_FOR_USER: 
      state = {
        ...state,
        managerUID: action.payload,
      };
      break;
      case types.SET_REGION_FOR_USER: 
      state = {
        ...state,
        region: action.payload,
      };
      break;
      case types.UPDATE_USER_SUCCESS:
      state = {
        ...state,
        email: action.payload.email,
        firstName: action.payload.firstName,
        fullName: action.payload.fullName,
        lastName: action.payload.lastName,
        managerUID: action.payload.managerUID,
        officeName: action.payload.officeName,
        phoneNumber: action.payload.phoneNumber,
        region: action.payload.region,
        role: action.payload.role,
        officeAddress: action.payload.officeAddress,
        officeCity: action.payload.officeCity,
        officeNumber: action.payload.officeNumber,
        officeState: action.payload.officeState,
        officeZip: action.payload.officeZip,
        currentPoints: action.payload.currentPoints,
        runningTotal: action.payload.runningTotal,
        bonusLevelRank: action.payload.bonusLevelRank,
      };
      break;
      default:
      break;    
    }

    return state;
};


export default userReducer;


// WEBPACK FOOTER //
// ./src/reducers/userReducer.js